import React from "react";
import "./style.scss";

const ContentWrapper = ( { children } ) => {

    return <div className = "contentWrapper" > {children} </div>;
    };


export default ContentWrapper;

// this component use to center all the content of our project

